export const ADMIN_API_ROOT = "/api/admin/v1";
